import { sizeClass, tileConfig, type TileRow } from './layout';
import { modulePath } from '../modules/registry';
import { getTileDef, type TileSize } from './registry';
import { TileFrame } from './TileFrame';

/** `linkTitles` (Today): each tile's title opens its module's dashboard. */
export function BentoGrid({
  tiles,
  label = 'Today tiles',
  linkTitles = false,
}: {
  tiles: TileRow[];
  label?: string;
  linkTitles?: boolean;
}) {
  return (
    <ul
      aria-label={label}
      className="grid grid-cols-2 gap-2.5 [grid-auto-flow:row_dense] md:grid-cols-4 md:gap-3"
    >
      {tiles.map((t) => {
        const def = getTileDef(t.type);
        if (!def) return null;
        const size = t.size as TileSize;
        const Body = def.Component;
        return (
          <li key={t.id} className={sizeClass[size]}>
            <TileFrame
              title={def.title}
              href={linkTitles && def.moduleId !== 'today' ? modulePath(def.moduleId) : undefined}
            >
              <Body size={size} config={tileConfig(t)} />
            </TileFrame>
          </li>
        );
      })}
    </ul>
  );
}
